<template>
  <header>
		<div class="content">
			<a class="logo" href="/"></a>
			<div class="nav">
				<router-link to="/home" active-class="current">首页</router-link>
				<router-link to="/about" active-class="current">关于我们</router-link>
				<router-link to="/innovation" active-class="current">技术创新</router-link>
				<router-link to="/case" active-class="current">应用案例</router-link>
				<router-link to="/news" active-class="current">新闻中心</router-link>
				<router-link to="/contact" active-class="current">联系我们</router-link>
			</div>
		</div>
	</header>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
header {
	width: 100%;
	height: 120px;
	background: #fff;
	display: flex;
	align-items: center;

	.content {
		display: flex;
		align-items: center;
	}
	.logo {
		width: 235px;
		height: 74px;
		background: url('../images/logo.png') no-repeat;
	}
	.nav {
		color: 000;
		font-size: 18px;
		margin-left: 200px;
		display: flex;

		a {
			margin: 0 40px;
		}
	}
}
</style>
